import { Button, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { ReactComponent as InfoIcon } from 'shared/assets/icons/warning.svg';

import styles from './ConfirmPopoverContent.module.scss';

const ConfirmPopoverContent = ({
  handleOk,
  handleCancel,
  title,
}: {
  handleOk: () => void;
  handleCancel: () => void;
  title: string;
}): React.ReactElement => {
  const { t } = useTranslation('Timesheet');

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div>
          <InfoIcon width={14} height={14} />
        </div>
        <Typography.Text>
          <Trans i18nKey={title} />
        </Typography.Text>
      </div>
      <div className={styles.buttonWrapper}>
        <Button type="default" size="small" onClick={handleCancel}>
          {t('statusConfirmPopover.cancelBtn.text')}
        </Button>
        <Button type="primary" size="small" onClick={handleOk}>
          {t('statusConfirmPopover.continueBtn.text')}
        </Button>
      </div>
    </div>
  );
};

export { ConfirmPopoverContent };
